import React from 'react';
import ReactDOM from 'react-dom';
import { loadDOMComponent } from '../../../helpers';
import { AppContextProvider } from '../../../Services/AppContext';
import { HealthPlanContextProvider } from '../../../Services/HealthPlanContext';
import HealthPlanWrapper from './HealthPlanWrapper';

loadDOMComponent({
	selector: 'react-health-plan-wrapper',
	callback: ({ container, context, props }) => {
		ReactDOM.render(
			<AppContextProvider {...context}>
				<HealthPlanContextProvider
					values={{
						healthPlan: context.healthPlan,
						setHealthPlan: () => {},
						healthPlanUser: context.healthPlanUser,
						setHealthPlanUser: () => {},
						healthPlanData: props.data,
						setHealthPlanData: () => {},
						activeHealthPlanUserItem: null,
						setActiveHealthPlanUserItem: () => {},
					}}>
					<HealthPlanWrapper {...props} />
				</HealthPlanContextProvider>
			</AppContextProvider>,
			container,
		);
	},
});
